import { useApiGet } from '../../api/Api.hooks';
import { Encouragement } from '../../models/Encouragement';

export function useGetUserEncouragement(id: number) {
  const { data, isLoading, error, get } = useApiGet<Encouragement>(
    `users/${id}/encouragement`
  );
  return {
    encouragement: data,
    loadingEncouragement: isLoading,
    loadingEncouragementError: error,
    getEncouragement: get
  };
}
